import {Button as SpringButton, tokens} from '@packages/systems/spring';
import {emotionStyled} from '@packages/utilities/styled';
import {brandedFontFamily} from '../../constants';

export const ButtonBrandedView = emotionStyled(SpringButton)(
  {
    fontSize: '15px',
    fontWeight: '600',
    lineHeight: '24px',
    fontFamily: brandedFontFamily,
    padding: '$3 $4',
    boxShadow:
      '0px 1px 1px 0px rgba(255, 255, 255, 0.20) inset, 0px 6px 12px 0px rgba(255, 255, 255, 0.12) inset, 0px 1px 2px 0px rgba(8, 8, 8, 0.20), 0px 4px 4px 0px rgba(8, 8, 8, 0.08)',
  },
  {
    variants: {
      colorVariant: {
        white: {
          background: tokens.colors.white,
          boxShadow:
            '0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.20), 0px 0px 2px 0px rgba(0, 0, 0, 0.10)',
        },
      },
      variant: {
        ghost: {
          boxShadow: 'none',
        },
        outline: {
          boxShadow: `0 0 0 1px ${tokens.colors.actionSecondaryBorder} inset`,
        },
      },
      //don't use this anymore, use density compact instead
      brandedVariant: {
        utility: {
          fontSize: '14px',
          fontWeight: '400',
          padding: '$2 $4',
        },
      },
      density: {
        compact: {
          padding: '$2 $4',
          fontSize: '14px',
          fontWeight: '400',
        },
      },
    },
  }
);
